import React, { useState } from 'react';

// mui
import { Container, Box } from '@mui/system';
import { Typography } from '@mui/material';

//block groups
import BaseTable from '../../../../../blockGroups/table/BaseTable/BaseTable.blockgroup.jsx';

// utils
import { createLogsList } from './EquipmentLogs.collection.utils.jsx';
import { dateComparator } from '../../../../../shared/sorting/dates.js';

const EquipmentLogsColumnConfigs = [
    {
        name: "date",
        title: "Date",
        objectFieldsToDisplay: ["date"],
        objectFieldsDelimeter: "",
        useNestedObject: false,
        type: 'date',
        sortComparator: dateComparator
    },
    {
        name: "type",
        title: "Type",
        objectFieldsToDisplay: ["typeTitle", "typeSubTitle"],
        objectFieldsDelimeter: " ",
        useNestedObject: false
    },
    {
        name: "quantity",
        title: "Amount",
        objectFieldsToDisplay: ["amountTitle", "amountSubTitle"],
        objectFieldsDelimeter: " ",
        useNestedObject: false,
        sortable: false
    },
    {
        name: "createdBy",
        title: "Created By",
        objectFieldsToDisplay: ["createdBy"],
        objectFieldsDelimeter: "",
        width: 250,
        useNestedObject: false
    },
]

const EquipmentLogs = ({ data = { equipment: { shippingLogs: [], adjustmentLogs: [], receivingLogs: [], cycleCountLogs: []} }, error, loading }) => {
    const [sortModel, setSortModel] = useState([{ field: "date", sort: "desc" }])
    const cleanedData = [...createLogsList(data.equipment)]


    return (<Container maxWidth={false} disableGutters sx={{ marginTop: 8, marginBottom: 8}}>
        <Typography variant='h4'>Logs</Typography>
        <Box sx={{ height: 500, width: "100%", marginTop: 2}}>
            <BaseTable 
                rawData={cleanedData}
                columnConfigs={EquipmentLogsColumnConfigs}
                loading={loading}
                sortModel={sortModel}
                onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
            />
        </Box>
    </Container>
    )
}

export default EquipmentLogs;